import {
  SO_UPDATE_DATA,
  SO_ENABLE_LOADING,
  SO_DISABLE_LOADING,
  SO_UPDATE_FILTER,
  SO_RESET_FILTER,
  SO_PAGINATION,
  SO_RESET_PAGINATION,
  SO_SET_MORE_FILTER,
  SO_APPLY_MORE_FILTER,
  SO_CANCEL_MORE_FILTER,
  SET_EXIM_TYPE,
} from '../actions/constants';
import moment from 'moment';

const defaultState = {
  isLoading: true,
  appliedFilters: {
    startDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    batchSize: 50,
    searchType: 'so_number_list',
    searchItems: [],
    moreFilters: {},
    moreFiltersTemp: {},
  },
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
  },
  eximType: '',
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case SO_UPDATE_DATA: {
      return {
        ...state,
        soData: action.data.data,
        pagination: {
          ...state.pagination,
          isNextPresent: action.data ? action.data.is_next_present : null,
          lastRowIdPrev: action.data ? action.data.last_item_id_prev : 0,
          lastRowIdNext: action.data ? action.data.last_item_id_next : 0,
          lastSortedColumnValuePrev: action.data ? action.data.last_sorted_column_value_prev : 0,
          lastSortedColumnValueNext: action.data ? action.data.last_sorted_column_value_next : 0,
          currentPageNumber: action.data ? action.data.current_page_number : 1,
        },
      };
    }
    case SO_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SO_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case SO_UPDATE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }
    case SO_SET_MORE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          moreFiltersTemp: {
            ...state.appliedFilters.moreFiltersTemp,
            ...action.data,
          },
        },
      };
    }
    case SO_APPLY_MORE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          moreFilters: { ...state.appliedFilters.moreFiltersTemp },
        },
      };
    }
    case SO_CANCEL_MORE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          moreFiltersTemp: {
            ...state.appliedFilters.moreFilters,
          },
        },
      };
    }
    case SO_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
      };
    }
    case SO_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case SO_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }
    case SET_EXIM_TYPE: {
      return {
        ...state,
        eximType: action.data,
      };
    }
    default: return state;
  }
}
